import { render } from "./VideoConference.vue?vue&type=template&id=0768567e"
import script from "./VideoConference.vue?vue&type=script&lang=js"
export * from "./VideoConference.vue?vue&type=script&lang=js"

import "./VideoConference.vue?vue&type=style&index=0&id=0768567e&lang=css"

import exportComponent from "/home/omar/intouch-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog,QCard,QCardSection,QSeparator,QCardActions});qInstall(script, 'directives', {ClosePopup});
